import type {ApiMethodName} from '../../../../api/types';
import type {CoreClientChannelsListParams} from '../../../../api/types/core/methods';
import type {Channel} from '../../types';

import {channelExpandCommon} from '../../../../api/channel';
import {postExpandCommon} from '../../../../api/channel/post';
import {createCollectionStore} from '../../../../api/utils/collectionStore';
import {extendExpand} from '../../../../api/utils/expand';
import {envManager} from '../../../../utils/env';

const channelWithLastPostExpand = extendExpand(channelExpandCommon, [
  ['last_post_id', {body: 'Post not found'}, postExpandCommon],
]);

export class ChannelsStoreFactory {
  private LIMIT = 300;
  private METHOD: ApiMethodName = 'client.channels.list';

  createCourseChannelsStore({
    archived,
    corporate,
    userId,
  }: {
    archived?: boolean;
    corporate?: boolean;
    userId?: string;
  } = {}) {
    const query: CoreClientChannelsListParams['query'] = [
      ['type', '==', 'course'],
      ['status', '==', archived ? 'archived' : 'active'],
      ['hidden_for_ids', '!contains', userId ? [userId] : []],
    ];

    if (!envManager.isB2b && corporate) {
      query.push(['subtenant_id', '!=', null]);
    }

    return createCollectionStore<Channel, CoreClientChannelsListParams>({
      method: this.METHOD,
      params: {
        expand: channelWithLastPostExpand,
        limit: this.LIMIT,
        query,
        sort: [['updated', -1]],
      },
    });
  }

  createDMChannelsStore(userId?: string) {
    return createCollectionStore<Channel, CoreClientChannelsListParams>({
      method: this.METHOD,
      params: {
        expand: channelWithLastPostExpand,
        limit: this.LIMIT,
        query: [
          ['type', '==', 'private'],
          ['hidden_for_ids', '!contains', userId ? [userId] : []],
        ],
        sort: [['updated', -1]],
      },
    });
  }
}
